import { render, staticRenderFns } from "./configkasteller.vue?vue&type=template&id=18912fe2&scoped=true"
import script from "./configkasteller.vue?vue&type=script&lang=js"
export * from "./configkasteller.vue?vue&type=script&lang=js"
import style0 from "./configkasteller.vue?vue&type=style&index=0&id=18912fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18912fe2",
  null
  
)

export default component.exports